import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { FixedLimitStackRoutes, FixedLimitStackScreenProps } from '@/features/account-management/screens/fixed-limit/type';
import { FixedLimitWebZeroScreen } from '@/features/account-management/screens/fixed-limit/FixedLimitWebZero.screen';
import { FixedLimitNativeZeroScreen } from '@/features/account-management/screens/fixed-limit/FixedLimitNativeZero.screen';

export const FixedLimitMain: React.FC<FixedLimitStackScreenProps<FixedLimitStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, func, record, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <FixedLimitNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <FixedLimitWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
